import { lazy, Suspense } from "react"
import { Route } from "react-router"
import Loading from "../../components/loadingScreen"
import TeamsLayout from "./Teams/layout"

const About = lazy(() => import("./About"))
const ExamInfo = lazy(() => import("./ExamInfo"))
const Syllabus = lazy(() => import("./Syllabus"))
const PastPapers = lazy(() => import("./PastPapers"))
const TeamProfiles = lazy(() => import("./Teams/teamProfiles"))
const Privacy = lazy(() => import("./Privacy"))
const Refund = lazy(() => import("./Refund"))
const Terms = lazy(() => import("./Terms"))
const Prizes = lazy(() => import("./Prizes"))

const resourcesList = [
  <Route
    key="index"
    index
    element={
      <Suspense fallback={<Loading />}>
        <About />
      </Suspense>
    }
  />,
  <Route
    key="about"
    path="about"
    element={
      <Suspense fallback={<Loading />}>
        <About />
      </Suspense>
    }
  />,
  <Route
    key="past-papers"
    path="past-papers/:cat"
    element={
      <Suspense fallback={<Loading />}>
        <PastPapers />
      </Suspense>
    }
  />,
  <Route
    key="syllabus"
    path="syllabus/:cat"
    element={
      <Suspense fallback={<Loading />}>
        <Syllabus />
      </Suspense>
    }
  />,
  <Route
    key="exam-info"
    path="exam-info"
    element={
      <Suspense fallback={<Loading />}>
        <ExamInfo />
      </Suspense>
    }
  />,
  <Route
    key="prize"
    path="prize"
    element={
      <Suspense fallback={<Loading />}>
        <Prizes />
      </Suspense>
    }
  />,
  <Route key="team" path="team" element={<TeamsLayout />}>
    <Route
      index
      element={
        <Suspense fallback={<Loading />}>
          <TeamProfiles team="all" />
        </Suspense>
      }
    />
    <Route
      path=":team"
      element={
        <Suspense fallback={<Loading />}>
          <TeamProfiles />
        </Suspense>
      }
    />
  </Route>,
  <Route
    key="privacy"
    path="privacy"
    element={
      <Suspense fallback={<Loading />}>
        <Privacy />
      </Suspense>
    }
  />,
  <Route
    key="refund"
    path="refund"
    element={
      <Suspense fallback={<Loading />}>
        <Refund />
      </Suspense>
    }
  />,
  <Route
    key="terms"
    path="terms"
    element={
      <Suspense fallback={<Loading />}>
        <Terms />
      </Suspense>
    }
  />,
  <Route key="not-found" path="*" element={"Resource Not Found"} />
]

export default resourcesList
